import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

const directionClass = {
  down: "rotate-0",
  up: "rotate-180",
  right: "-rotate-90",
  left: "rotate-90",
  "up-right": "-rotate-[135deg]",
} as const;

/** A compact carrot silhouette for buttons and directional controls. */
export function CarrotIcon({
  direction = "down",
  className,
  ...props
}: SVGProps<SVGSVGElement> & { direction?: keyof typeof directionClass }) {
  return (
    <svg
      viewBox="0 0 20 24"
      fill="none"
      className={cn(
        "carrot-icon pointer-events-none block shrink-0 origin-[50%_28%]",
        directionClass[direction],
        className,
      )}
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g fill="var(--carrot-icon-leaf, currentColor)" opacity="0.72">
        <path d="M9.4 7.3C7.9 3.6 5.8 1.6 2.9.8c.8 2.9 2.7 5.4 6.5 6.5Z" />
        <path d="M9.9 7.1C9.4 3.5 9.9 1.2 11.3 0c1 2.7.7 5.1-.5 7.3Z" />
        <path d="M10.6 7.3c1.5-3.8 3.6-5.8 6.5-6.5-.8 2.9-2.7 5.4-6.5 6.5Z" />
      </g>
      <path
        fill="var(--carrot-icon-body, currentColor)"
        opacity="var(--carrot-icon-body-opacity, 1)"
        d="M3.3 8.2C6.7 7.1 13.3 7.1 16.7 8.2c-.8 6.3-3.1 12.2-6.7 15.6C6.4 20.4 4.1 14.5 3.3 8.2Z"
      />
    </svg>
  );
}
